'use client'

// React Imports
import { useState } from 'react'

// MUI Imports
import { keyframes } from '@mui/material/styles'

// The refused-close feedback (Luca 2026-07-22, the create-VM wizard precedent —
// views/vms/create/index.tsx): a backdrop click or Esc on a create/edit dialog
// SHAKES the paper instead of silently discarding edits, and the UI says so —
// only the explicit close/cancel buttons close it. Consumers put the animation
// on slotProps.paper.sx while `shaking` holds.
export const shakeFrames = keyframes`
  0%, 100% { transform: translateX(0) }
  20% { transform: translateX(-8px) }
  40% { transform: translateX(8px) }
  60% { transform: translateX(-5px) }
  80% { transform: translateX(5px) }
`

// State + trigger: shake() arms the 0.35s animation and disarms after 400ms so
// the next refused close retriggers it.
export const useDialogShake = (): { shaking: boolean; shake: () => void } => {
  // States
  const [shaking, setShaking] = useState(false)

  const shake = () => {
    setShaking(true)
    window.setTimeout(() => setShaking(false), 400)
  }

  return { shaking, shake }
}
